// Generated by CoffeeScript 1.9.3
var React, createStyles;

React = require('react');

createStyles = require('../utils/createStyles');

module.exports = function(styles) {
  return React.createClass({
    displayName: "TypographyStyle",
    render: function() {
      return React.DOM.style({
        id: "typography.js",
        dangerouslySetInnerHTML: {
          __html: styles()
        }
      });
    }
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/typography/dist/components/TypographyStyle.js
 ** module id = 450
 ** module chunks = 0
 **/